import React from "react";

import PageHero from "../../components/common/PageHero";
import PageSectionHeader from "../../components/common/PageSectionHeader";
import ScrollIndicator from "../Home/ScrollIndicator";
import useScrollToTop from "../../hooks/useScollToTop";

import ProjetDetail from "./components/ProjetDetail";
import ProjetLightbox from "./components/ProjetLightbox";
import ProjetsEmptyState from "./components/ProjetsEmptyState";
import ProjetsSkeleton from "./components/ProjetsSkeleton";
import ProjetsSummary from "./components/ProjetsSummary";

import { PROJETS_PAGE } from "./data/projetsUiData";
import { useProjetsPage } from "./hooks/useProjetsPage";

export default function ProjetsPage() {
  useScrollToTop();

  const {
    loading,
    error,
    projets,
    total,
    selectedProjet,
    selectedId,
    zoomImage,
    selectProjet,
    openZoom,
    closeZoom,
    refresh,
  } = useProjetsPage();

  return (
    <>
      <PageHero
        title={PROJETS_PAGE.title}
        imageUrl={PROJETS_PAGE.heroImageUrl}
        crumbs={PROJETS_PAGE.crumbs}
      />

      <ScrollIndicator />

      <main className="mx-auto max-w-[1240px] px-4 pb-16 pt-6 sm:px-6 md:pt-8">
        <PageSectionHeader
          eyebrow={PROJETS_PAGE.eyebrow}
          title={PROJETS_PAGE.title}
          description={PROJETS_PAGE.description}
        >
          <div className="rounded-3xl border border-slate-200 bg-white/80 px-5 py-4 shadow-sm backdrop-blur dark:border-slate-800 dark:bg-slate-950/70">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
              Projets actifs
            </p>
            <p className="mt-1 text-3xl font-bold text-slate-950 dark:text-white">
              {loading ? "…" : total}
            </p>
            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              projet{total > 1 ? "s" : ""} publié{total > 1 ? "s" : ""}
            </p>
          </div>
        </PageSectionHeader>

        {error && (
          <div className="mt-5 rounded-3xl border border-red-200 bg-red-50 px-5 py-4 text-sm font-semibold text-red-700 dark:border-red-900/60 dark:bg-red-950/30 dark:text-red-300">
            Une erreur est survenue pendant le chargement des projets.
          </div>
        )}

        <section className="mt-6 space-y-6">
          {loading ? (
            <ProjetsSkeleton />
          ) : projets.length > 0 ? (
            <>
              <ProjetsSummary
                loading={loading}
                projets={projets}
                selectedId={selectedId}
                onSelect={selectProjet}
                onRefresh={refresh}
              />

              <ProjetDetail projet={selectedProjet} onZoom={openZoom} />
            </>
          ) : (
            <ProjetsEmptyState />
          )}
        </section>
      </main>

      <ProjetLightbox
        projet={selectedProjet}
        isOpen={zoomImage}
        onClose={closeZoom}
      />
    </>
  );
}